module.exports = __webpack_public_path__ + "static/img/productPartner_10_4.7906c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_10_4.png
// module id = L2kc
// module chunks = 34